import api from "./axios";

export const reportApi = {

  /* ===================== GENERIC REPORT ===================== */
  report: async ({ targetId, targetType, reason }) => {
    if (!targetId || !targetType || !reason) {
      throw new Error("targetId, targetType and reason are required");
    }

    switch (targetType) {
      case "post": {
        const res = await api.post(
          `/feeds/${targetId}/report`,
          { reason }
        );
        return res.data;
      }

      case "comment": {
        const res = await api.post(
          `/comments/${targetId}/report`,
          { reason }
        );
        return res.data;
      }

      case "reply": {
        const res = await api.post(
          `/comments/${targetId}/report`,
          { reason }
        );
        return res.data;
      }

      default:
        throw new Error(`Invalid targetType: ${targetType}`);
    }
  },

};
